/**
 * @return {string}
 */
export default function getOriginalHostname() {
  return window?.$dt?.objConfig?.OriginalHostname || '';
}
